<template>
    <div>
        <div class="fist-page-text" v-html="page.firstPageText"></div>
            <MbLoading v-if="isLoading"></MbLoading>
            <div v-else-if="pageErrors.length > 0">
                <h3>Attenzione</h3>
                <p v-for="(error, key) in pageErrors" :key="key">
                    {{error}}
                </p>

                <div class="row">
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <button @click="goToHome()" id="my-submit" class="go-to-cart-button button red-button button-full" type="button">Torna alla home</button>
                    </div>
                </div>
            </div>
            <template v-else>
                <form id="RegisterForm" novalidate="">
                    <div class="row pl-2 pr-2 pl-sm-4 pr-sm-4 pl-md-4 pr-md-4">
                        <div class="col-12 mb-3">
                            <div class="bold-text-line text-uppercase margin-top-md">Tipologia</div>
                        </div>

                        <MbRadioTipoCliente v-model="form.tipoCliente" :options="tipiCliente"></MbRadioTipoCliente>                        
                    </div>

                    <div class="row grey-container p-4 mobile-padding-sm mobile-padding-top-sm">
                        <div v-if="form.tipoCliente && form.tipoCliente == 'Ente'" class="col-12 col-sm-12">
                            <mb-input-text label="Nome ente" 
                                v-model="form.nomeEnte" 
                                :errors="errors['nomeEnte']"
                                :max-length="100"></mb-input-text>
                        </div>
                        <template v-else>
                            <div class="col-12 col-sm-6">
                                <mb-input-text label="Nome" v-model="form.nome" :errors="errors['nome']" :max-length="200"></mb-input-text>
                            </div>
                            <div class="col-12 col-sm-6">
                                <mb-input-text label="Cognome" v-model="form.cognome"  :errors="errors['cognome']" :max-length="200"></mb-input-text>
                            </div>
                        </template>

                        <div class="col-12">
                            <mb-input-text label="Email" v-model="form.email" :errors="errors['email']" :max-length="200"></mb-input-text>
                        </div>

                        
                        <template v-if="form.tipoCliente == 'Ente'">
                            <div :class="{
                                'col-12 col-sm-4': page.progessioniPersoneGiuridicheNestedFilter == true,
                                'col-12': page.progessioniPersoneGiuridicheNestedFilter == false
                            }">
                                <mb-input-drop-down 
                                    label="Tipologia organizzazione"
                                    v-model="form.professionePersonaGiuridica[0]"
                                    :values="professioniPersoneGiuridiche"
                                    @change="cleenProfessione(form.professionePersonaGiuridica, 0)"
                                    :errors="errors['professionePersonaGiuridica']"></mb-input-drop-down>
                            </div>
                            <div class="col-12 col-sm-4" v-if="form.professionePersonaGiuridica[0] && form.professionePersonaGiuridica[0].children && form.professionePersonaGiuridica[0].children.length > 0">
                                <mb-input-drop-down 
                                    label="&nbsp;"
                                    v-model="form.professionePersonaGiuridica[1]"
                                    :values="form.professionePersonaGiuridica[0].children"></mb-input-drop-down>
                            </div>
                        </template>
                        <template v-else>
                            <div :class="{
                                'col-12 col-sm-4': page.progessioniPersoneFisicheNestedFilter == true,
                                'col-12': page.progessioniPersoneFisicheNestedFilter == false
                            }">
                                <mb-input-drop-down 
                                    label="Professione"
                                    :values="professioniPersoneFisiche"
                                    v-model="form.professionePersonaFisica[0]"
                                    @change="cleenProfessione(form.professionePersonaFisica, 0)"
                                    :errors="errors['professionePersonaFisica']"></mb-input-drop-down>
                            </div>
                            <div class="col-12 col-sm-4" v-if="form.professionePersonaFisica[0] && form.professionePersonaFisica[0].children && form.professionePersonaFisica[0].children.length > 0">
                                <mb-input-drop-down  
                                    label="&nbsp;"
                                    :values="form.professionePersonaFisica[0].children"
                                    v-model="form.professionePersonaFisica[1]"
                                    @change="cleenProfessione(form.professionePersonaFisica, 1)"></mb-input-drop-down>
                            </div>
                            <div class="col-12 col-sm-4" v-if="form.professionePersonaFisica[1] && form.professionePersonaFisica[1].children && form.professionePersonaFisica[1].children.length > 0">
                                <mb-input-drop-down  
                                    label="&nbsp;"
                                    :values="form.professionePersonaFisica[1].children"
                                    v-model="form.professionePersonaFisica[2]"
                                    @change="cleenProfessione(form.professionePersonaFisica, 2)"></mb-input-drop-down>
                            </div>
                        </template>

                        <div class="col-12"></div>

                        <div v-if="page.richiediAreeInteresse" class="mb-5">
                            <div class="col-12 mb-3">
                                <div class="bold-text-line text-uppercase margin-top-md">Aree di interesse</div>
                            </div>

                            <div class="col-12" v-for="(area, index) in areeInteresse" :key="index">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :id="'area-' + index" :value="area" v-model="form.areeInteresse">
                                    <label class="form-check-label" :for="'area-' + index">
                                        {{ area }}
                                    </label>
                                </div>
                            </div>

                            <ul v-if="errors['areeInteresse']" class="parsley-errors-list filled" style="position: relative;">
                                <li class="parsley-marketingFlagValidator">
                                    {{errors['areeInteresse'][0]}}
                                </li>
                            </ul>
                        </div>

                        <template v-for="(meta, mkey) in page.metadatas">
                            <div class="col-12"></div>
                            <div v-if="meta.type.value == 'MbFileUpload'"
                                class="col-12"
                                style="margin-bottom: 20px;">
                                <MbFileUpload 
                                    :label="meta.label" 
                                    v-model="form.metaValues[meta.name]"
                                    :required="meta.required"
                                    :maxAttachments="1"
                                    :displayDownload="false"
                                    :displayWatch="false"
                                    :displayMove="false"
                                    :options="{
                                        maxSize: meta.options.maxSize ? meta.options.maxSize * 1000000 : null,
                                        extensions: meta.options.extensions ? getFileUploadExtensions(meta.options.extensions) : null
                                    }"
                                    ></MbFileUpload>

                                <ul v-if="errors[meta.name]" class="parsley-errors-list filled" style="position: relative;">
                                    <li class="parsley-marketingFlagValidator">
                                        {{errors[meta.name][0]}}
                                    </li>
                                </ul>
                            </div>
                            <div v-else-if="meta.type.value == 'MbProductSelect'"
                                class="col-12">
                                <mb-input-drop-down  
                                    :label="meta.label"
                                    :values="meta.options.products ? meta.options.products : []"
                                    v-model="form.metaValues[meta.name]"
                                    :errors="errors[meta.name]">
                                </mb-input-drop-down>
                            </div>
                            <div v-else-if="meta.type.value == 'MbTextField'"
                                class="col-12">
                                <mb-input-text 
                                    :label="meta.label" 
                                    v-model="form.metaValues[meta.name]" 
                                    :errors="errors[meta.name]" 
                                    :max-length="meta.options.maxLength ? meta.options.maxLength : 100">
                                </mb-input-text>
                            </div>
                            <template v-else-if="meta.type.value == 'MbAddress'">
                                <div class="col-12 col-sm-8">
                                    <mb-input-text label="Indirizzo" v-model="form.metaValues[meta.name].indirizzo" :errors="errors[meta.name + '_indirizzo']" :max-length="200"></mb-input-text>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <mb-input-text label="Civico" v-model="form.metaValues[meta.name].civico"  :errors="errors[meta.name + '_civico']" :max-length="200"></mb-input-text>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <mb-input-text label="CAP" v-model="form.metaValues[meta.name].cap" :errors="errors[meta.name + '_cap']" :max-length="200"></mb-input-text>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <mb-input-text label="Città" v-model="form.metaValues[meta.name].citta"  :errors="errors[meta.name + '_citta']" :max-length="200"></mb-input-text>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <mb-input-text label="Provincia" v-model="form.metaValues[meta.name].provincia"  :errors="errors[meta.name + '_provincia']" :max-length="200"></mb-input-text>
                                </div>
                            </template>
                            <template v-else-if="meta.type.value == 'MbScuola'">
                                <div class="col-12">
                                    <MbScuolaSelect :label="meta.label" v-model="form.metaValues[meta.name]" 
                                        :errors="errors[meta.name]">
                                    </MbScuolaSelect>
                                </div>
                            </template>
                        </template>

                        <template v-if="page.privacyTypeDictionaryValue == 'checkbox'">
                            <div class="col-12">
                                <p class="margin-top-sm">
                                    Letta e compresa <a :href="page.privacyDocumentUrl" target="_blank" class="masked-link">l’<u>Informativa</u> sul trattamento dei miei dati personali</a>
                                </p>
                            </div>

                            <div class="col-12 col-sm-3 margin-bottom-sm radio-parsley">
                                <div class="input-container e-checkbox-container no-min-h parsley-error" >
                                    <input v-model="form.consensoPrivacy" type="checkbox" class="e-checkbox" name="consenso" :value="true" id="radio-accetto">
                                    <label for="radio-accetto">Do il consenso</label>
                                </div>
                                <ul v-if="errors['consensoPrivacy']" class="parsley-errors-list filled">
                                    <li v-for="(error, i) in errors['consensoPrivacy']" :key="i" class="parsley-marketingFlagValidator">
                                        {{error}}
                                    </li>
                                </ul>
                            </div>

                            <div class="col-12">
                                <p>al trattamento dei miei dati per l’invio della newsletter di Edizioni Centro Studi Erickson Spa.</p>
                            </div>
                        </template>
                        <template v-else-if="page.privacyTypeDictionaryValue == 'radiobutton'">
                            <div class="col-12">
                                <p class="margin-top-sm">
                                    Letta e compresa 
                                    <a :href="page.privacyDocumentUrl" target="_blank" class="masked-link"><u>l’informativa sul trattamento dei miei dati personali</u></a>
                                </p>
                            </div>
                            
                             <div class="col-12 col-sm-3 margin-bottom-sm radio-parsley">
                                <div class="input-container e-radio-container no-min-h" >
                                    <input v-model="form.consensoPrivacy" type="radio" class="e-radio" name="consenso" :value="true" id="radio-accetto">
                                    <label for="radio-accetto">Do il consenso</label>
                                </div>
                                <ul v-if="errors['consensoPrivacy']" class="parsley-errors-list filled">
                                    <li v-for="(error, i) in errors['consensoPrivacy']" :key="i" class="parsley-marketingFlagValidator">
                                        {{error}}
                                    </li>
                                </ul>
                            </div>

                            <div class="col-12 col-sm-3 margin-bottom-sm">
                                <div class="input-container e-radio-container no-min-h">
                                    <input v-model="form.consensoPrivacy" type="radio" class="e-radio" name="consenso" :value="false" id="radio-rifiuto">
                                    <label for="radio-rifiuto">Nego il consenso</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <p>al trattamento dei miei dati per l’invio di materiale informativo e promozionale, a mezzo i) posta cartacea, ii) sms e app e iii) e-mail.</p>
                            </div>
                        </template>
                        <template v-else-if="page.privacyTypeDictionaryValue == 'marketing_radio_profilazione'">
                            <div class="col-12">
                                <p class="margin-top-sm">
                                    Letta e compresa 
                                    <a :href="page.privacyDocumentUrl" target="_blank" class="masked-link"><u>l’informativa</u></a> 
                                    sul trattamento dei miei dati personali ai sensi dell'art. 13 del regolamento UE 2016/679 (cd. GDPR):
                                </p>
                            </div>
                            
                             <div class="col-12 col-sm-3 margin-bottom-sm radio-parsley">
                                <div class="input-container e-radio-container no-min-h" >
                                    <input v-model="form.consensoPrivacy" type="radio" class="e-radio" name="consenso" :value="true" id="radio-accetto">
                                    <label for="radio-accetto">Do il consenso</label>
                                </div>
                                <ul v-if="errors['consensoPrivacy']" class="parsley-errors-list filled">
                                    <li v-for="(error, i) in errors['consensoPrivacy']" :key="i" class="parsley-marketingFlagValidator">
                                        {{error}}
                                    </li>
                                </ul>
                            </div>

                            <div class="col-12 col-sm-3 margin-bottom-sm">
                                <div class="input-container e-radio-container no-min-h">
                                    <input v-model="form.consensoPrivacy" type="radio" class="e-radio" name="consenso" :value="false" id="radio-rifiuto">
                                    <label for="radio-rifiuto">Nego il consenso</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <p>al trattamento dei miei dati personali per l'analisi e la previsione delle mie preferenze, abitudini di consumo e interessi.</p>
                            </div>
                        </template>
                    </div>
                </form>

                <div class="row" v-if="errors['errors'] && errors['errors'].length > 0">
                    <div class="col-12">
                        <center>
                            <ul class="parsley-errors-list filled" id="parsley-id-18">
                                <li v-for="(error, index) in errors['errors']" :key="index" 
                                    class="parsley-required">{{error}}</li>
                            </ul>
                        </center>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <ul v-if="errors['form']" class="parsley-errors-list filled">
                            <li v-for="(error, i) in errors['form']" :key="i" class="parsley-marketingFlagValidator">
                                {{error}}
                            </li>
                        </ul>
                         <vue-recaptcha
                            ref="recaptcha"
                            :loadRecaptchaScript="true"
                            @verify="onCaptchaVerified"
                            @expired="onCaptchaExpired"
                            size="invisible"
                            :sitekey="recaptchaKey">
                        </vue-recaptcha>
                    </div>
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <div class="grecaptcha-badge">
                            <button @click="onClickSubmit()" id="btn-create-account" 
                                :disabled="submitted"
                                class="go-to-cart-button button red-button button-full g-recaptcha" type="button" >
                                {{page.firstPageCTAText}}
                            </button>
                        </div>
                    </div>
                </div>

                <div v-html="page.firstPageFooterText"></div>
                <MbScriptField :value="page.firstPageScript"></MbScriptField>
                <div class="text-center">
                    <small>
                        Consulta la <a href="/cookie-policy">cookie policy</a>
                    </small>
                </div>
                
            </template>
    </div>
</template>

<script>
import Constants from "@/constants/Constants"
import CodiceFiscale from "codice-fiscale-js"
import VueRecaptcha from 'vue-recaptcha'

import MediaLibraryAPI from "@/service/MediaLibraryAPI"
import MbPageService from "./MbPageService"

import MbRadioTipoCliente from "@/components/newsletter_form/MbRadioTipoCliente"
import MbInputText from "@/components/newsletter_form/MbInputText"
import MbInputDropDown from "@/components/newsletter_form/MbInputDropDown"
import MbLoading from "@/components/newsletter_form/MbLoading"
import MbFileUpload from "@/components/newsletter_form/MbFileUpload"
import MbScriptField from "@/components/newsletter_form/MbScriptField"
import MbScuolaSelect from "@/components/newsletter_form/MbScuolaSelect"

export default {
    name: 'home',
    components: {
        MbRadioTipoCliente,
        MbInputText,
        MbInputDropDown,
        MbLoading,
        MbFileUpload,
        MbScriptField,
        'vue-recaptcha': VueRecaptcha,
        MbScuolaSelect
    },
    data(){
        return {
            recaptchaKey: Constants.RECAPTCHA_KEY,
            page: {},
            pageErrors: [],
            isLoading: false,
            submitted: false,
            professioniPersoneFisiche: [],
            professioniPersoneGiuridiche: [],
            tipiCliente: ["Privato", "Ente"],
            areeInteresse: ['Didattica',
                'DSA',
                'ADHD',
                'DOP e disturbi del comportamento',
                'BES e inclusione',
                'Difficoltà di linguaggio',
                'Autismo',
                'Disabilità',
                'Psicologia',
                'Lavoro sociale',
                'Genitorialità e famiglie',
                'Saggistica'],
            errors: {},
            form: {
                nome: "",
                cognome: "",
                nomeEnte: "",
                email: "",
                tipoCliente: "Privato",
                consensoPrivacy: null,
                professionePersonaFisica: [null, null, null],
                professionePersonaGiuridica: [null, null],
                areeInteresse: [],
                metaValues: {}
            }
        }
    },
    watch: {
    },
    metaInfo() {
        return { 
            title: this.page.metaTitle ? this.page.metaTitle : "Edizioni Erickson: " + this.page.name,
            meta: [
                { name: 'description', content: this.page.metaDescription},
                { property: 'og:title', content: this.page.metaTitle},
                { property: 'og:image', content: this.page.ogImage ? this.page.ogImage.url : null},
                { property: 'og:type', content: 'website'},    
                { name: 'robots', content: 'index,follow'} 
            ]
        }
    },
    created(){
        this.loadPage();
    },
    methods: {
        loadPage(){
            this.isLoading = true

            let pagePermalink = this.$route.params.pagePermalink
            MediaLibraryAPI.getPage(pagePermalink)
                .then(({ data }) => {
                    if (!data) {
                        this.$router.push("/page-not-found")
                        return
                    }

                    this.page = data.data
                    if (!this.page) {
                        this.$router.push("/page-not-found")
                        return
                    }

                    if (data.hasErrors) {
                        this.pageErrors = data.errors
                        this.isLoading = false
                        return
                    }

                    MbPageService.setPage(this.page)

                    this.loadSubscriptionForm()
                }).catch((errors) => {
                    this.pageErrors.push(errors)
                    this.isLoading = false
                })
        },
        loadSubscriptionForm(){
            this.isLoading = true;

            for (let f in this.page.metadatas){
                let field = this.page.metadatas[f]
                if (field.type.value == 'MbAddress'){
                    this.$set(this.form.metaValues, field.name, {
                        indirizzo: '',
                        civico: '',
                        cap: '',
                        citta: '',
                        provincia: ''
                    });
                } else if (field.type.value == 'MbFileUpload'){
                    this.$set(this.form.metaValues, field.name, null);
                } else if (field.type.value == 'MbScuola'){
                    this.$set(this.form.metaValues, field.name, {
                        provincia: null,
                        scuola: null
                    });
                } else {
                    this.$set(this.form.metaValues, field.name, null);
                }
            }

            this.professioniPersoneFisiche = this.page.professioniPersoneFisiche
            this.professioniPersoneGiuridiche = this.page.professioniPersoneGiuridiche

            if (window.fbq){
                let fbqData = {
                    "evento": this.page.name
                }

                let eventName = "InitialPage"

                if (this.page.permalink.indexOf("ericksonscuola") != -1) {
                    eventName = "EricksonScuolaInitialPage"
                } else if (this.page.permalink.indexOf("scarica-il-capitolo") != -1) {
                    eventName = "NarrativaPrimoCapitoloInitialPage"
                } else if (this.page.permalink.indexOf("iscrizione-webinar") == 0) {
                    eventName = "SubscribeWebinarInitialPage"
                } else if (this.page.permalink.indexOf("corso-online") == 0 || this.page.permalink.indexOf("master") == 0) {
                    eventName = "FreeLessonInitialPage"
                }

                if (eventName) {
                    window.fbq('trackCustom', eventName, fbqData)
                }
            }

            this.isLoading = false
        },
        cleenProfessione(data, level){
            for (var k in data){
                if (k > level){
                    data[k] = null;
                }
            }
        },
        deepCheck(arr){
            if (!Array.isArray(arr)){
                return false;
            }
            for (var i = 0; i < arr.length; i++){
                if (!arr[i]){
                    return false;
                } else if (!Array.isArray(arr[i].children) || arr[i].children.length == 0){
                    return true;
                }
            }
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        onCaptchaExpired(){
            this.$refs.recaptcha.reset()
        },
        onClickSubmit(){
            this.submitted = true
            this.$refs.recaptcha.execute()
        },
        onCaptchaVerified(recaptchaToken){
            this.errors = {};
            
            if (!this.form.email || this.form.email == ""){
                this.errors["email"] = ["Dato richiesto."]
            } else {
                this.form.email = this.form.email.trim()
                if (!this.validateEmail(this.form.email)){
                    this.errors["email"] = ["Indirizzo non valido."]
                }
            }

            if (this.form.tipoCliente == 'Privato'){
                if (!this.form.nome || this.form.nome == ""){
                    this.errors["nome"] = ["Dato richiesto."]
                }
                if (!this.form.cognome || this.form.cognome == ""){
                    this.errors["cognome"] = ["Dato richiesto."]
                }
                
                if (!this.deepCheck(this.form.professionePersonaFisica)){
                    this.errors["professionePersonaFisica"] = ["Selezionare la professione."]
                }
            } else {
                if (!this.form.nomeEnte || this.form.nomeEnte == ""){
                    this.errors["nomeEnte"] = ["Dato richiesto."]
                }

                if (!this.deepCheck(this.form.professionePersonaGiuridica)){
                    this.errors["professionePersonaGiuridica"] = ["Selezionare la tipologia."]
                }
            }
                          
            if (this.page.privacyTypeDictionaryValue == "checkbox"){
                if (this.form.consensoPrivacy != true){
                    this.errors["consensoPrivacy"] = ["È necessario acconsentire al trattamento dati per procedere."]
                }
            } else if (this.page.privacyTypeDictionaryValue == "radiobutton"){
                if (this.form.consensoPrivacy == null){
                    this.errors["consensoPrivacy"] = ["Effettuare una scelta per proseguire la registrazione."]
                } 
            } else if (this.page.privacyTypeDictionaryValue == "marketing_radio_profilazione"){
                if (this.form.consensoPrivacy == null){
                    this.errors["consensoPrivacy"] = ["Effettuare una scelta per proseguire la registrazione."]
                }
            }

            if (this.page.metadatas){
                this.page.metadatas.forEach((meta) => {
                    if (meta.options == null){
                        return
                    }

                    if (meta.type.value == 'MbScuola'){
                            this.validateSchool(meta)
                            return
                        }

                    if (meta.options.required){
                        if (meta.type.value == 'MbAddress'){
                            this.validateAddress(meta)
                            return
                        }

                        if (!this.form.metaValues[meta.name] || 
                            this.form.metaValues[meta.name] == "" ||
                            this.form.metaValues[meta.name].length == 0){
                                this.errors[meta.name] = [
                                    "Specificare un valore"
                                ]
                            }
                    }

                    if (meta.type.value == "MbTextField"){
                        this.validateTextField(meta)
                    }
                })
            }

            if (Object.keys(this.errors).length !== 0){
                this.$refs.recaptcha.reset()
                this.submitted = false
                return
            }

            this.isLoading = true
            this.pageErrors = []

            MediaLibraryAPI.postNewsletter({
                pageId: this.page.pageId,
                nome: this.form.nome,
                cognome: this.form.cognome,
                nomeEnte: this.form.nomeEnte,
                email: this.form.email,
                tipoCliente: this.form.tipoCliente,
                consensoPrivacy: this.form.consensoPrivacy,
                areeInteresse: this.form.areeInteresse,
                professionePersonaFisicaDictionaryId: this.getLastDictionaryId(this.form.professionePersonaFisica),
                professionePersonaGiuridicaDictionaryId: this.getLastDictionaryId(this.form.professionePersonaGiuridica),
                metaValues: this.form.metaValues,
                recaptchaToken: recaptchaToken
            }).then(({ data }) => {
                this.submitted = false

                if (data.hasErrors) {
                    this.pageErrors = data.errors
                    this.isLoading = false
                    return
                }

                if (Object.keys(data.data.errors).length !== 0){
                    this.errors = data.data.errors
                    this.isLoading = false
                    return
                }

                if (data.data.otp) {
                    this.$router.push("/iscrizioni/" + this.page.permalink + "/conferma/" + data.data.otp)
                } else {
                    this.$router.push("/iscrizioni/" + this.page.permalink + "/conferma")
                }
            }).catch((errors) => {
                this.submitted = false

                this.pageErrors.push(errors)
                this.isLoading = false
            });
        },
        validateAddress(meta){
            let metaNames = [
                "indirizzo",
                "civico",
                "cap",
                "citta",
                "provincia",
            ]

            metaNames.forEach((element) => {
                if (!this.form.metaValues[meta.name][element] || 
                    this.form.metaValues[meta.name][element] == "" ||
                    this.form.metaValues[meta.name][element].length == 0){
                        this.errors[meta.name + "_" + element] = [
                            "Specificare un valore"
                        ]
                    }
            })
        },
        validateSchool(meta){
            let metaNames = [
                "provincia",
                "scuola"
            ]

            const value = this.form.metaValues[meta.name];
            if (!value || !value.provincia || !value.scuola) {
                this.errors[meta.name] = [
                    "Specificare provincia e scuola"
                ]
                return;
            }

            if (!value.provincia.dictionaryId || !value.scuola.scuolaId) {
                this.errors[meta.name] = [
                    "Specificare provincia e scuola"
                ]
                return;
            }
        },
        validateTextField(meta){
            if (!meta.options.validator || meta.options.validator.length == 0){
                return
            }

            meta.options.validator.forEach(() => {
                try{
                    CodiceFiscale.computeInverse(this.form.metaValues[meta.name])
                } catch (ex){
                    this.errors[meta.name] = [
                        "Valore non valido"
                    ]
                }
            })
        },
        getLastDictionaryId(arr){
            if (!arr || !Array.isArray(arr)){
                return null;
            }

            var dictionaryId = null;
            for (let i = 0; i < arr.length; i++){
                if (arr[i] != null){
                    dictionaryId = arr[i].dictionaryId;
                } else {
                    return dictionaryId;
                }
            }
            return dictionaryId;
        },
        goToHome(){
            location.href = 'https://www.erickson.it';
        },
        getFileUploadExtensions(ext){
            let res = []
            ext.forEach(element => {
                res.push(element.value)
            });
            return res
        }
    }
}
</script>
<style scoped>
.fist-page-text{
    padding-top: 20px;
}
</style>